export default Object.freeze({
    RECEIVED: 'received',
    INTREATMENT: 'intreatment',
    COMPLETED: 'completed',
});
